import { useContext, useEffect, useRef, useState } from 'react';
import { getCustomisationFieldData, getCustomisationValue, updateCustomisationValue } from '../../../EditablePreview/EditablePreview';
import ModuleNumericalInput from '../../components/ModuleNumericalInput';
// import './CustomModule.scss';
import { changeNumericalFieldValue, changeStringFieldValue, changeValue_noType } from '../../ModuleList';
import ModuleTextInput from '../../components/ModuleTextInput';
import { ShowColorPicker } from '../../../../../../forms/ColorPicker/ColorPickerPopUp';
import { CampaignContext } from "../../../../../../../contexts/CampaignContext";

import ImageIcon from '../../../../WorkspaceAssets/ListIcons/image-icon.png';
import { COLOUR_NAME_TO_COLOUR_HEX } from '../../../../../../../helpers/Colours';

const DropdownField = (props) => {
    const fieldData = props.fieldData;
    const moduleConfig = props.moduleConfig;
    const groupConfig = props.groupConfig;
    const customisationVars = props.customisationVars;

    const [campaignContext, setCampaignContext] = useContext(CampaignContext);

    let optionsData = null;
    if (fieldData?.customFieldConfig?.dataLink) {
        optionsData = getCustomisationFieldData(campaignContext.campaignData, props.selectedFeatureNode.path, fieldData.customFieldConfig.dataLink);
    }
    const findDisplayValue = (value) => {
        console.log("Custom dropdown: Finding display value for:", value, optionsData, typeof value);
        const option = optionsData?.valOptions?.find(opt => (opt.value === value || opt.val === value));
        return option ? option.label : value;
    }

    const [currentValue, setCurrentValue] = useState(getCustomisationValue(customisationVars, fieldData?.customFieldConfig?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) ?? null);
    const [valueType, setValueType] = useState(typeof currentValue);
    const valueType_ref = useRef(valueType);
    useEffect(() => {
        setCurrentValue(getCustomisationValue(customisationVars, fieldData?.customFieldConfig?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) ?? null);
        const newValueType = typeof getCustomisationValue(customisationVars, fieldData?.customFieldConfig?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode);
        setValueType(newValueType);
        valueType_ref.current = newValueType;
    }, [customisationVars, fieldData, props.index, props.visualisationComponentKey, props.selectedFeatureNode]);

    const changeFieldValue = (fieldId, value) => {
        const valueType_loc = valueType_ref.current;
        console.log("Custom dropdown: Changing field value:", fieldId, value, typeof value, valueType_loc);
        let valChanged = false;
        switch (valueType_loc) {
            case 'number':
                valChanged = changeNumericalFieldValue(customisationVars, fieldData?.customFieldConfig, value, true, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode);
                value = Number(value);
                break;
            case 'string':
                valChanged = changeStringFieldValue(customisationVars, fieldData?.customFieldConfig, value, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode);
                break;
            case 'boolean':
                valChanged = changeValue_noType(customisationVars, fieldData?.customFieldConfig, value, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode);
                value = (value === 'true' || value === 'True' || value === true);
                break;
            default:
                valChanged = changeValue_noType(customisationVars, fieldData?.customFieldConfig, value, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode);
                // console.warn("Custom dropdown: Unsupported value type:", valueType_loc);
                break;
        }
        if (valChanged) {
            setCurrentValue(value);
        }
        props?.forceUpdateComponent?.();
    }

    return (
        <>
            <div className='v2-module-field-label'>{fieldData?.customFieldConfig?.customFieldLabel ?? 'Choose'}</div>
            <ModuleTextInput
                value={findDisplayValue(currentValue)}
                fieldId={'custom-drop-down'}
                enabled={props.isEnabled && optionsData?.valOptions?.length > 0}
                editable={false}
                onChange={changeFieldValue}
                hiddenDropDown={true}
                hiddenDropDownOptions={optionsData?.valOptions || []}
                dropDownValue={currentValue}
            />
        </>
    );
};

export default DropdownField;